import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attachment",
  "use": "attachment-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"attachment\"><path d=\"M249.87 171l-70.79 70.8a25.05 25.05 0 0 1-35.43-35.43l87.89-87.89A45.59 45.59 0 0 1 296 183l-92.5 92.5A66.13 66.13 0 0 1 110 182l64.56-64.56\" fill=\"none\" stroke=\"#3c4859\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"13\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol